/**
 * Utility functions for handling file URLs in the web platform
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3000';

/**
 * Rebuilds a file URL with the current user's token
 * This is needed because file URLs from mobile app contain pet owner's tokens,
 * but vets need to use their own tokens to access files
 */
export function rebuildFileUrlWithCurrentToken(originalUrl) {
  if (!originalUrl) return null;
  
  // If it's already a public URL (not our proxy), return as-is
  if (originalUrl.includes('r2.dev') || originalUrl.includes('cloudflare')) {
    return originalUrl;
  }
  
  // Extract the key from the original URL
  const urlObj = new URL(originalUrl);
  const key = urlObj.searchParams.get('key');
  
  if (!key) return originalUrl;
  
  // Get the current vet's token
  const vetToken = localStorage.getItem('vetToken');
  if (!vetToken) return originalUrl;
  
  // Rebuild the URL with the vet's token
  return `${API_BASE}/api/storage/file?key=${encodeURIComponent(key)}&token=${encodeURIComponent(vetToken)}`;
}

/**
 * Processes an array of files and rebuilds their URLs with the current token
 */
export function processFilesWithCurrentToken(files) {
  if (!Array.isArray(files)) return [];
  
  return files.map(file => ({
    ...file,
    url: rebuildFileUrlWithCurrentToken(file.url || file.fileUrl)
  }));
}

/**
 * Rebuilds a single URL (for pet profile images, seizure videos, etc.)
 */
export function rebuildSingleUrlWithCurrentToken(url) {
  return rebuildFileUrlWithCurrentToken(url);
}
